// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ShopListUserDetailsScreen_tabs__2Fe8z","rotate":"ShopListUserDetailsScreen_rotate__3ehIL"};